var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2173,
    height: 1296,
    viewBox: "0 0 2173 1296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.216 848.561H16.3223L0 700.179L309.33 275.312H552.287V685.941H637.004V848.561H552.287V972.565H354.252V848.561H354.216ZM354.216 685.941V476.582L203.126 685.941H354.216Z",
    fill: "#427161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1890.21 848.561H1552.32L1536 700.179L1845.33 275.312H2088.28V685.941H2173V848.561H2088.28V972.565H1890.25V848.561H1890.21ZM1890.21 685.941V476.582L1739.12 685.941H1890.21Z",
    fill: "#427161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.03 881.227C1491.45 736.437 1491.45 501.688 1346.03 356.898C1200.61 212.109 964.828 212.109 819.405 356.898C673.981 501.688 673.981 736.437 819.405 881.227C964.828 1026.02 1200.61 1026.02 1346.03 881.227Z",
    fill: "#427161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.46 619.062C1496.46 846.614 1311.17 1031.09 1082.62 1031.09",
    stroke: "#427161",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1468.9 199.703C1468.11 215.702 1454.42 228.035 1438.35 227.244C1422.28 226.453 1409.89 212.826 1410.69 196.827C1411.48 180.827 1425.17 168.495 1441.24 169.286C1457.31 170.077 1469.69 183.704 1468.9 199.703Z",
    stroke: "#5A9E8C",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.18 158.37C1008.34 162.181 1063.05 236.174 1061.93 234.268L1100.6 189.002L1035.93 139.062L1007.18 158.406V158.37Z",
    fill: "#EF9E7B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.35 136.215L1037.84 201.759L1005.74 156.709L1045.35 136.215Z",
    fill: "#D67F61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.56 180.061C1044.77 180.061 1070.88 154.064 1070.88 121.995C1070.88 89.9265 1044.77 63.9297 1012.56 63.9297C980.35 63.9297 954.24 89.9265 954.24 121.995C954.24 154.064 980.35 180.061 1012.56 180.061Z",
    fill: "#EF9E7B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9558_2845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 954,
    y: 63,
    width: 117,
    height: 118
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.56 180.061C1044.77 180.061 1070.88 154.064 1070.88 121.995C1070.88 89.9265 1044.77 63.9297 1012.56 63.9297C980.35 63.9297 954.24 89.9265 954.24 121.995C954.24 154.064 980.35 180.061 1012.56 180.061Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9558_2845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960.776 84.5786C960.776 84.5786 968.648 111.472 1015.77 124.415L1026.39 129.521C1026.39 129.521 1050.4 171.695 1091.39 154.401C1091.39 154.401 1106.2 104.066 1045.49 67.2848C1001.37 40.5352 960.74 84.5786 960.74 84.5786H960.776Z",
    fill: "#060E38"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M959.585 146.59L957.346 160.54C957.093 162.23 958.61 163.632 960.271 163.236L969.732 161.007L959.585 146.59Z",
    fill: "#EF9E7B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.48 121.929C1047.01 132.14 1038.34 140.086 1028.05 139.618C1017.8 139.151 1009.82 130.522 1010.28 120.275C1010.75 110.064 1019.42 102.119 1029.71 102.586C1039.97 103.053 1047.95 111.682 1047.48 121.929Z",
    fill: "#EF9E7B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.63 127.449C1021.63 127.449 1020.83 115.8 1033.22 113.211",
    stroke: "#060E38",
    strokeWidth: 0.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.26 63.7722C1121.73 85.776 1104.21 104.005 1082.11 104.508C1060.01 104.975 1041.71 87.5377 1041.2 65.534C1040.69 43.5302 1058.24 25.3016 1080.34 24.7982C1102.44 24.3308 1120.75 41.7685 1121.26 63.7722Z",
    fill: "#060E38"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.39 1083.08L1385.66 1116.59L1413.86 1066.08L1364.86 1031.13L1338.39 1083.08Z",
    fill: "#EF9E7B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1370.68 1120.93L1415.49 1058.19L1482.37 1103.57L1397.11 1222.9C1393.14 1228.47 1384.29 1225.16 1384.98 1218.37L1395.52 1139.12L1370.68 1120.93Z",
    fill: "#060E38"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1384.29 1216.33L1470.74 1095.31",
    stroke: "#FFDABC",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1389.13 1175.46L1401.16 1171.29",
    stroke: "#FFDABC",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.19 1159.96L1403.21 1155.79",
    stroke: "#FFDABC",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.49 494.785L1067.27 516.214C1067.27 516.214 959.007 849.47 1327.02 1108.7C1327.02 1108.7 1366.96 1078.64 1399.31 1020.25C1399.31 1020.25 1117.39 851.375 1191.49 494.821",
    fill: "#012442"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M909.862 1161.63V1219.41H969.59L969.771 1159.4L909.862 1161.63Z",
    fill: "#EF9E7B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M898.954 1214.03H976.268L977.893 1294.56H830.812C823.915 1294.56 821.495 1285.47 827.49 1282.09L898.448 1244.7L898.918 1214.03H898.954Z",
    fill: "#060E38"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M828.753 1280.38H977.929",
    stroke: "#FFDABC",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M865.009 1260.63L875.373 1267.93",
    stroke: "#FFDABC",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M878.912 1253.3L889.276 1260.64",
    stroke: "#FFDABC",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.28 415.522L1066.4 441.049C1066.4 441.049 892.78 689.346 884.005 1176.88C884.005 1176.88 944.456 1190.15 996.492 1176.88C996.492 1176.88 989.559 765.101 1161.85 577.206C1161.85 577.206 1242.7 509.901 1196.62 400.457L1061.24 415.522H1061.28Z",
    fill: "#005482"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M884.943 1141.93C884.943 1141.93 938.893 1148.87 996.888 1141.93",
    stroke: "#060E38",
    strokeWidth: 0.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.67 440.868L1205.47 428.5",
    stroke: "#060E38",
    strokeWidth: 0.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M983.093 438.296C923.257 439.806 855.006 395.907 799.142 342.839C782.603 327.163 791.703 318.966 807.484 302.499C823.228 286.032 849.409 285.421 865.948 301.132C909.065 342.084 951.604 360.241 992.446 355.135C1068.39 345.643 1122.16 261.368 1122.7 260.505C1134.76 241.269 1160.26 235.337 1179.61 247.31C1198.97 259.282 1204.96 284.522 1193.01 303.829C1190.01 308.647 1118.58 421.973 1003.35 436.75C996.599 437.613 989.846 438.153 983.093 438.296Z",
    fill: "#EF9E7B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9558_2845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 790,
    y: 241,
    width: 410,
    height: 198
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M983.093 438.296C923.257 439.806 855.006 395.907 799.142 342.839C782.603 327.163 791.703 318.966 807.484 302.499C823.228 286.032 849.409 285.421 865.948 301.132C909.065 342.084 951.604 360.241 992.446 355.135C1068.39 345.643 1122.16 261.368 1122.7 260.505C1134.76 241.269 1160.26 235.337 1179.61 247.31C1198.97 259.282 1204.96 284.522 1193.01 303.829C1190.01 308.647 1118.58 421.973 1003.35 436.75C996.599 437.613 989.846 438.153 983.093 438.296Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9558_2845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1045.82 319.003L1043.58 453.362L1146.17 419.098L1085.36 299.156L1045.82 319.003Z",
    fill: "#D67F61"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M867.358 316.881L865.769 303.722L871.547 306.347L853.347 270.069C851.83 267.085 849.772 264.317 847.027 262.411C840.708 257.953 835.616 259.93 831.102 259.427C823.519 258.6 825.866 260.865 825.758 268.451C817.849 268.595 801.491 272.118 792.499 237.279C790.585 229.837 782.821 225.271 775.31 227.104C763.971 229.909 783.616 224.695 783.074 229.801C783.074 230.017 783.074 230.232 783.074 230.448C780.366 227.931 776.502 226.817 772.674 227.751C767.944 228.938 764.657 232.893 764.188 237.459C764.116 238.07 764.116 238.681 764.188 239.293C762.419 238.825 760.505 238.717 758.627 239.221C753.896 240.407 750.61 244.362 750.141 248.928C749.996 250.187 750.105 251.517 750.43 252.847C750.538 253.315 750.682 253.746 750.791 254.213C750.574 254.249 750.393 254.249 750.177 254.285C745.446 255.472 745.229 257.557 744.724 262.123C744.579 263.382 744.688 264.712 745.013 266.042C747.468 275.93 749.924 279.885 753.643 287.255C753.643 287.255 753.716 287.399 753.824 287.579C755.593 291.066 757.471 294.23 759.494 297.142C770.941 315.299 799.649 350.893 832.294 358.911C875.736 369.589 867.394 316.881 867.394 316.881H867.358Z",
    fill: "#EF9E7B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M727.172 211.094L727.389 217.601C727.461 219.651 728.184 221.592 729.484 223.174L811.167 320.753C813.479 323.521 817.92 327.117 821.567 327.009L857.39 326.11C861.326 326.002 865.587 322.299 867.393 317.517L759.853 214.617L727.172 211.094Z",
    fill: "#03081D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M728.112 213.557L817.379 317.859C819.185 319.981 821.857 321.167 824.638 321.131L863.602 320.664C866.599 320.664 868.224 317.104 866.238 314.839L777.151 211.652C774.732 208.847 771.193 207.265 767.473 207.301L730.784 207.733C727.787 207.733 726.198 211.256 728.112 213.557Z",
    fill: "#060E38"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M743.895 217.099L824.82 311.657C826.12 313.167 827.998 314.03 829.984 313.994L852.157 313.743C854.829 313.743 856.237 310.579 854.504 308.565L775.384 216.919C773.217 214.438 770.076 213 766.789 213.036L745.628 213.288C743.678 213.288 742.631 215.589 743.895 217.099Z",
    fill: "#F7F4ED"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M839.623 259.547L819.906 256.563C811.637 255.304 805.101 263.466 808.17 271.232C809.181 273.713 811.059 275.762 813.478 276.949L848.904 294.206L843.668 271.484L839.587 259.583L839.623 259.547Z",
    fill: "#EF9E7B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.45 237.544C1047.45 237.544 1034.27 223.127 1058.25 196.701C1085.91 166.176 1101.22 175.883 1114.22 181.816L1047.45 237.544Z",
    fill: "#D80650"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.66 400.456C1196.66 400.456 1159.57 347.784 1164.37 306.76C1169.18 265.737 1179.14 194.009 1122.12 175.637C1122.12 175.637 1096.95 175.709 1075 197.353C1056.11 213.64 1010.97 259.517 1035.02 308.234C1037.98 314.275 1041.02 318.985 1044.02 322.58C1046.18 348.683 1051.56 379.351 1061.31 415.521L1196.69 400.456H1196.66Z",
    fill: "#F03C3A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.73 300.778L1165.2 403.966L1215.33 398.429L1119.74 248.609L1131.73 300.778Z",
    fill: "#D9004B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.5 593.342C1247.72 595.14 1248.08 596.865 1248.51 598.591L1227.79 636.235C1225.04 641.232 1225.84 647.416 1229.74 651.551C1235.04 657.196 1244.11 657.088 1249.27 651.299L1253.5 646.554C1259.74 651.731 1267.33 664.315 1250.36 697.896C1247.5 703.54 1249.78 710.443 1255.45 713.284C1259.89 715.513 1265.09 714.614 1268.48 711.414C1268.63 711.27 1268.77 711.091 1268.92 710.911C1269.31 714.614 1271.55 718.066 1275.16 719.899C1279.61 722.128 1284.81 721.23 1288.2 718.03C1288.63 717.598 1289.07 717.131 1289.43 716.628C1290.48 718.174 1291.88 719.504 1293.69 720.403C1298.13 722.632 1303.33 721.733 1306.73 718.533C1307.7 717.634 1308.49 716.556 1309.11 715.333C1309.33 714.902 1309.51 714.47 1309.72 714.039C1309.9 714.147 1310.05 714.291 1310.23 714.362C1314.67 716.592 1319.87 715.693 1323.26 712.493C1324.24 711.594 1325.03 710.515 1325.65 709.293C1330.34 700.017 1333.7 691.28 1335.76 683.119C1335.76 683.119 1335.76 682.975 1335.83 682.759C1336.81 678.912 1337.46 675.209 1337.82 671.613C1340.49 653.996 1343.78 619.552 1334.13 592.335C1334.46 589.135 1334.46 585.827 1334.03 582.484C1314.67 429.968 1248.48 314.052 1201.64 248.652L1131.55 300.821C1172.1 357.916 1230.39 460.061 1247.32 593.378L1247.5 593.342Z",
    fill: "#EF9E7B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.89 188.604C1135.95 171.49 1108.33 171.31 1091.07 188.101C1073.84 204.963 1073.63 232.504 1090.56 249.653C1091.03 250.121 1108.47 268.062 1131.73 300.78L1201.82 248.611C1175.39 211.686 1155.09 190.869 1152.85 188.604H1152.89Z",
    fill: "#F03C3A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.73 300.775L1090.56 249.648",
    stroke: "#060E38",
    strokeWidth: 0.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M572.473 40.3945L593.346 49.2032",
    stroke: "#427161",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M625.015 8.60938V26.8739",
    stroke: "#427161",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M583.667 0.308594L602.987 29.7188",
    stroke: "#427161",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M838.755 46.3164H621.69C617.083 46.3164 613.348 50.0349 613.348 54.6218V121.028C613.348 125.615 617.083 129.334 621.69 129.334H838.755C843.362 129.334 847.097 125.615 847.097 121.028V54.6218C847.097 50.0349 843.362 46.3164 838.755 46.3164Z",
    fill: "#5A9E8C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M707.962 121.727L729.845 146.427L752.487 121.727H707.962Z",
    fill: "#5A9E8C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M637.868 76.4922H813.731",
    stroke: "white",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M637.868 95.1836H735.008",
    stroke: "white",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M514.189 1294.57H1651.91",
    stroke: "#427161",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.b82bc382d86da4d67ce958cb1d7697c8.svg";
export { ForwardRef as ReactComponent };